import { assign, fromPromise, setup } from 'xstate'
import manifest from '/resource/manifest.json?url'
import { Ga4EventType, ga4Info, initLanguage, sleep } from '@slot-nx/core'
import { assetManager } from '../assetManager'
import { inGame } from '../inGame/inGame'
import { gameSupportLanguages } from '../../config'

export const screenMachine = setup({
  types: {
    events: {} as {
      type: 'exit tutorial'
    },
    context: {} as {
      enterGodziLoadingStartTime: number
    },
  },
  actors: {
    waitGodziSlotLoading: fromPromise(async () => {
      ga4Info.addEvent(Ga4EventType.godzi_loading)
      async function loadEssentialAssets() {
        await assetManager.init(manifest)
        await assetManager.loadEssential()
      }

      async function loadLanguage() {
        const urlParams = new URLSearchParams(window.location.search)
        await initLanguage(urlParams.get('lang'), false, gameSupportLanguages)
      }

      await Promise.all([sleep(3000), loadEssentialAssets(), loadLanguage(), inGame()])
    }),
  },
  actions: {
    loadBackgroundAssets: () => {
      assetManager.loadBackground()
    },
    setEnterGodziLoadingTime: assign({
      enterGodziLoadingStartTime: () => Date.now(),
    }),
    recordGodziLoadingTime: ({ context }) => {
      const loadingTime = Date.now() - context.enterGodziLoadingStartTime
      ga4Info.addEvent(Ga4EventType.tutorial_loading_time, {
        sec: `${loadingTime}`,
      })
    },
  },
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5SwMYCcxgHYDoDiA9hAF4CWAygDYEAuABADIECGEpWUAxBAVmDuwBuBANb9UGbPiJkqtRizYcEQgimY1SvANoAGALp79iUAAcCsUpt4mQAD0QBaAIwBWAJw4AbLveuALADMrq66gQBMruEA7AA0IACeiM44AByuwc6pztG6-h7RXqmBAL4l8RKYuAAqAK40BGikzJScYHZWdDT1jc2URrbmltZYtg4I-s6BOL6Burqp7s7+S6le-vFJCOHTurnuXhG6XtFR0YHRZeUgWERwtpXYgxZWWqNI9k7+0ak4gUFecJ5cLOdypYpeTZOZzzHDudy6GK6KLZFb+fxlCroKrSEgUaj0JisdhQZ7DN5jL5zP4AoH+EFgiFQhAuaZeE6BHL5dxzVJ5VKYkCPGo9JotMmvGwfcbOcJeHDheE+aIxEEBenMxy6BUhNbHGH7YpTVyC4X4ZgAWzAEpGlIQrlS-hw52czhOyyKri8rmZORwUzy3zybsCnICVxKQA */
  id: 'screen',
  initial: 'GodziSlot Loading',
  context: () => ({
    enterGodziLoadingStartTime: 0,
  }),
  states: {
    'GodziSlot Loading': {
      invoke: [
        {
          src: 'waitGodziSlotLoading',
          onDone: {
            target: 'Tutorial',
          },
        },
      ],

      entry: 'setEnterGodziLoadingTime',
    },

    'Tutorial': {
      entry: ['loadBackgroundAssets', 'recordGodziLoadingTime'],

      on: {
        'exit tutorial': 'Game',
      },
    },

    'Game': {},
  },
})
